module.exports = __webpack_public_path__ + "img/arrow_left.4b0a081d.svg";